import React from 'react'
import {Component} from 'react'

import Tree from 'cms_plugins/zitat_display/js/components/Tree'
import SearchLink from 'cms_plugins/expert_search/js/components/SearchLink'


class TableLoading extends Component {




    render()
    {
        const {headers} = this.props
        let rows=[]
        for (let i=0; i<30;i++){
            rows.push(
                <tr className={ i & 1 ?"placeholder-content": ""} key={i} >
                        <td style={{height:'3rem'}} />
                        {headers ? headers.map((h, i) => (
                        <td key={i}> </td>
                    )) : null}
                    </tr>
            )
        }

        return (
            <table className={"results"}>
                <thead>
                <tr>
                    <th/>
                    {headers ? headers.map((h, i) => (
                        <th key={i}
                            
                        >{h}</th>
                    )) : null}
                </tr>
                </thead>
                <tbody>
                {
                    rows
                }
                </tbody>
            </table>
        );
    }
}

export default TableLoading;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/loading/TableLoading.js